export default __webpack_public_path__ + "static/media/ResourceNest_Purple_Positive_RGB.49b3b21a.svg";